import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import EventoForm from './EventoForm';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import EventoTable from "./EventoTable";
import EventoTurmaTable from "../EventoTurma/EventoTurmaTable";
import TurmaFindDialogRedux from "../../Turma/TurmaSelectDialogRedux";
import EngajamentoTable from "../EventoUsuario/EngajamentoTable";
import EventoAlunoTable from "../EventoAluno/EventoAlunoTable";
import AlunoFindDialogRedux from "../../Aluno/AlunoFindDialogRedux";

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    table: {
        paddingTop: '20px',
        margin: '20px'
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});

export default function ComunicadoContainer() {
    const classes = useStyles();
    const evento = useSelector(state => state.evento);

    return (
        <div>
            <TurmaFindDialogRedux />
            <AlunoFindDialogRedux />
            <Container className={classes.paper} component={Paper}>

                <Typography className={classes.title} variant="h6">
                    Eventos
                </Typography>

                <Grid style={{ marginBottom: '20px' }} container justify="space-around">


                    {evento ?
                        <Grid size={7}>
                            <EventoForm />
                        </Grid>
                        : ''}


                    <Grid size={4}>
                        {evento && evento.codigo && evento.enviarPor === 'Turma' ?
                            <EventoTurmaTable />
                            : ''}
                        {evento && evento.codigo && evento.enviarPor === 'Aluno' ?
                            <EventoAlunoTable />
                            : ''}
                    </Grid>



                </Grid>
                <Grid>
                    {evento ?
                        ''
                        : <EventoTable />}
                </Grid>
                <Grid>
                    {evento && evento.codigo && evento.enviado ?
                        <EngajamentoTable />
                        : ''}
                </Grid>
            </Container>
        </div>
    );
}